module.exports = __webpack_public_path__ + "static/media/credit-cards.66ae9401.png";